import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from "./Container";
import styled from "@emotion/styled";
import { colors } from "./theme";
export function RTCButton({ backgroundColor = colors.redMain, content = "NO CONTENT", contentColor = colors.white, external = "0", size = "medium", url = "#", }) {
    return (_jsx(ContainerStyled, { children: _jsx(LinkStyled, Object.assign({ backgroundColor: backgroundColor, contentColor: contentColor, fontSize: fontSizes[size], href: url, title: content }, (external === "1"
            ? {
                target: "_blank",
                rel: "noopener noreferrer",
            }
            : {
                target: "_self",
            }), { children: content }), void 0) }, void 0));
}
const ContainerStyled = styled(Container)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});
const LinkStyled = styled.a(({ backgroundColor, contentColor, fontSize }) => ({
    borderRadius: "0.4rem",
    textDecoration: "none",
    padding: "calc(1em - 0.2rem) calc((1em - 0.2rem) * 2)",
    display: "inline-block",
    backgroundColor,
    color: contentColor,
    fontSize,
    "&:hover": {
        opacity: 0.5,
    },
}));
const fontSizes = {
    big: "1.8rem",
    medium: "1.6rem",
    small: "1.4rem",
};
//# sourceMappingURL=Button.js.map